<template>
  <section class="direction-section" :class="{ 'is-active': isActive }">
    <!-- 헤더 영역 여백 (흰색) -->
    <div class="header-space"></div>
    <!-- 타이틀 -->
    <div class="direction-title" :class="{ 'is-active': isActive }">
      <p class="title-eng">Directions</p>
      <p class="title-kor">찾아오시는 길</p>
    </div>

    <!-- 지도 이미지 -->
    <div class="map-wrap" :class="{ 'is-active': isActive }">
      <div class="map-item">
        <img src="@/assets/direction_map2_251029.jpg" alt="단지 위치도" class="map-img" />
        <div class="map-info">
          <span class="map-label">현장</span>
        </div>
        <div class="map-info-line">
          <span class="map-address">C3BL : 경기 수원시 권선구 금곡동 866</span>
        </div>
        <div class="map-info-line">
          <span class="map-address">D3BL : 경기 수원시 권선구 당수동 728-13</span>
        </div>
      </div>
    </div>

    <!-- VIEW MORE 버튼 -->
    <div class="view-btn" :class="{ 'is-active': isActive }" @click="$router.push('/location/direction')">
      <svg class="view-rotate-text" viewBox="0 0 160 160">
        <defs>
          <path id="dirCirclePath" d="M80,80 m-65,0 a65,65 0 1,1 130,0 a65,65 0 1,1 -130,0" />
        </defs>
        <text text-anchor="middle">
          <textPath href="#dirCirclePath" startOffset="25%">VIEW MORE</textPath>
        </text>
        <text text-anchor="middle">
          <textPath href="#dirCirclePath" startOffset="75%">VIEW MORE</textPath>
        </text>
      </svg>
      <span class="view-center">VIEW</span>
    </div>

    <!-- 배경 이미지 -->
    <div class="bg-layer">
      <img src="@/assets/bg_direction1.jpg" alt="" class="bg-img" />
    </div>

  </section>
</template>

<script>
export default {
  name: 'DirectionSection',
  props: {
    isActive: {
      type: Boolean,
      default: false
    }
  }
}
</script>

<style scoped>
.direction-section {
  width: 100%;
  height: 100vh;
  position: relative;
  overflow: hidden;
  background: #fff;
}

.direction-title {
  position: absolute;
  top: 300px;
  left: 240px;
  z-index: 2;
  display: flex;
  align-items: baseline;
  gap: 20px;
}

.title-eng {
  font-family: var(--font-family2);
  font-size: 64px;
  font-weight: 700;
  color: #fff;
  letter-spacing: 2px;
  opacity: 0;
  transform: translateY(20px);
  transition: opacity 0.8s cubic-bezier(0.16, 1, 0.3, 1), transform 0.8s cubic-bezier(0.16, 1, 0.3, 1);
}

.title-kor {
  font-family: var(--font-family3);
  font-size: 24px;
  font-weight: 700;
  color: #fff;
  opacity: 0;
  transform: translateY(20px);
  transition: opacity 0.8s cubic-bezier(0.16, 1, 0.3, 1) 0.2s, transform 0.8s cubic-bezier(0.16, 1, 0.3, 1) 0.2s;
}

.direction-title.is-active .title-eng,
.direction-title.is-active .title-kor {
  opacity: 1;
  transform: translateY(0);
}

.map-wrap {
  position: absolute;
  top: 390px;
  left: 240px;
  display: flex;
  gap: 20px;
  z-index: 2;
}

.map-img {
  height: 340px;
  width: auto;
  border-radius: 8px;
  opacity: 0;
  transform: translateY(20px);
  transition: opacity 0.8s cubic-bezier(0.16, 1, 0.3, 1), transform 0.8s cubic-bezier(0.16, 1, 0.3, 1);
}

.map-item {
  display: flex;
  flex-direction: column;
}

.map-info {
  margin-top: 12px;
  display: flex;
  align-items: center;
  gap: 10px;
}

.map-label {
  font-family: var(--font-family);
  font-size: 20px;
  font-weight: 700;
  color: var(--thehue-primary);
}

.map-address {
  font-family: var(--font-family);
  font-size: 18px;
  font-weight: 400;
  color: #999;
}

/* VIEW MORE 버튼 */
.view-btn {
  position: absolute;
  top: 200px;
  right: 360px;
  width: 110px;
  height: 110px;
  border-radius: 50%;
  background: var(--thehue-primary);
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  overflow: visible;
  z-index: 2;
  opacity: 0;
  transform: translateY(20px);
  transition: opacity 0.8s ease 0.5s, transform 0.8s ease 0.5s, background 0.3s ease;
}

.view-btn.is-active {
  opacity: 1;
  transform: translateY(0);
}

.view-btn:hover {
  background: var(--sub-color);
}

.view-rotate-text {
  position: absolute;
  width: 155%;
  height: 155%;
  animation: dirRotate 10s linear infinite;
}

.view-rotate-text text {
  font-family: var(--font-family2);
  font-size: 11px;
  font-weight: 600;
  fill: var(--thehue-primary);
  letter-spacing: 2px;
}

.view-center {
  font-family: var(--font-family2);
  font-size: 15px;
  font-weight: 700;
  color: #fff;
  letter-spacing: 1px;
  transition: color 0.3s ease;
}

.view-btn:hover .view-center {
  color: var(--thehue-primary);
}

@keyframes dirRotate {
  0% { transform: rotate(0deg); }
  100% { transform: rotate(360deg); }
}

.map-info-line {
  margin-top: 4px;
}

.map-wrap.is-active .map-item:nth-child(1) {
  opacity: 0;
  transform: translateY(20px);
  animation: fadeUp 0.8s cubic-bezier(0.16, 1, 0.3, 1) 0.4s forwards;
}

.map-wrap.is-active .map-item:nth-child(2) {
  opacity: 0;
  transform: translateY(20px);
  animation: fadeUp 0.8s cubic-bezier(0.16, 1, 0.3, 1) 0.6s forwards;
}

@keyframes fadeUp {
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

.map-wrap.is-active .map-img:nth-child(1) {
  opacity: 1;
  transform: translateY(0);
  transition-delay: 0.4s;
}

.map-wrap.is-active .map-img:nth-child(2) {
  opacity: 1;
  transform: translateY(0);
  transition-delay: 0.6s;
}

.header-space {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 130px;
  background: #fff;
  z-index: 1;
}

.bg-layer {
  position: absolute;
  top: 130px;
  left: 0;
  width: 100%;
  height: calc(100% - 130px);
}

.bg-img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

/* 모바일 반응형 */
@media (max-width: 768px) {
  .direction-section {
    height: auto;
    min-height: auto;
    overflow: hidden;
  }

  .header-space {
    height: 0;
    display: none;
  }

  .bg-layer {
    top: 0;
    height: 100%;
  }

  .direction-title {
    position: relative;
    top: auto;
    left: auto;
    flex-direction: column;
    gap: 4px;
    padding: 60px 24px 0;
    z-index: 2;
  }

  .title-eng {
    font-size: 28px;
    letter-spacing: 1px;
  }

  .title-kor {
    font-size: 14px;
  }

  .map-wrap {
    position: relative;
    top: auto;
    left: auto;
    flex-direction: column;
    gap: 20px;
    padding: 24px 24px 80px;
    z-index: 2;
  }

  .map-img {
    width: 100%;
    height: auto;
    border-radius: 8px;
  }

  .map-label {
    font-size: 14px;
  }

  .map-address {
    font-size: 12px;
    word-break: keep-all;
  }

  .map-info {
    margin-top: 8px;
  }

  /* VIEW 버튼 모바일에서 숨김 */
  .view-btn {
    display: none;
  }
}
</style>
